import { FC } from 'react';
import { useHistory } from 'react-router';

import { verifactuConnectiondialog } from 'modules/Documents/List/messages';
import useTranslations from 'modules/I18n/hooks/useTranslations';
import { useCloseModal, MODAL_WIDTH_DEFAULT } from 'modules/Modals';
import { Dialog } from 'modules/Modals/components/Dialog';
import { ModalTypes } from 'modules/Modals/constants';
import { Text, Button } from 'modules/Ui';
import { ROUTES } from 'pages/verifactu/routesMap';

const VerifactuInfoConnectionDialog: FC = () => {
  const closeModal = useCloseModal();
  const {
    t,
    formatHelpers: { bold },
  } = useTranslations();
  const history = useHistory();
  const handleVerifactuTest = () => {
    history.push(ROUTES.VERIFACTU_CREATE_TEST);
    closeModal();
  };

  const handleClose = () => {
    closeModal();
  };

  const texts = [
    { id: '02', msg: verifactuConnectiondialog.dialogText02 },
    { id: '03', msg: verifactuConnectiondialog.dialogText03 },
    { id: '04', msg: verifactuConnectiondialog.dialogText04 },
    { id: '05', msg: verifactuConnectiondialog.dialogText05 },
  ];

  return (
    <Dialog
      type="fullScreen"
      onClose={handleClose}
      title={t(verifactuConnectiondialog.dialogTitle)}
      btnSecondayHasVisibleMobile
      dialogWidth={{
        sm: MODAL_WIDTH_DEFAULT,
      }}
      buttonPrimary={
        <Button onClick={() => console.log('Firma...')} variant="secondary">
          {t(verifactuConnectiondialog.dialogCtacConnect)}
        </Button>
      }
      buttonSecondary={
        <Button
          onClick={handleVerifactuTest}
          marginBottom={{ _: '16px', sm: '0' }}
          variant="stroke"
        >
          {t(verifactuConnectiondialog.dialogCtaTest)}
        </Button>
      }
      content={
        <>
          <Text
            color="gray800"
            fontSize={16}
            fontWeight={700}
            lineHeight={26}
            marginBottom="16px"
          >
            {t(verifactuConnectiondialog.dialogText01)}
          </Text>
          {texts.map(({ id, msg }) => (
            <Text
              key={id}
              color="gray600"
              fontSize={16}
              lineHeight={22}
              marginBottom="16px"
            >
              {t(msg, { strong: bold() })}
            </Text>
          ))}
        </>
      }
      id={ModalTypes.VERIFACTU_CONFIRMATION_DIALOG}
    />
  );
};

export default VerifactuInfoConnectionDialog;
